export type RecursionalString = string | RecursionalString[];

export const getLastString = (str: RecursionalString): string => {
  if (typeof str === "string") {
    return str;
  }
  return getLastString(str[str.length - 1]);
};
